import React from 'react';
import ReactMarkdown from 'react-markdown';
import styles from './styles.module.scss';

import Certificates from '../Certificates';

import Config from '../../../config/config';

const ProductDescription = ({
  refToDescription,
  refToUsage,
  refToIngredients,
  spanish,
  content,
  cmsData,
}) => (
  <div className={styles.container} ref={refToDescription}>
    <div className={styles.block}>
      <h4>
        {spanish
          ? content?.DescriptionTitleSpanish
          : content?.DescriptionTitleEnglish}
      </h4>
      {cmsData && (
        <ReactMarkdown
          children={
            spanish ? cmsData?.DescriptionSpanish : cmsData?.DescriptionEnglish
          }
        />
      )}
    </div>

    {cmsData?.Usage && (
      <div className={styles.block} ref={refToUsage}>
        <h4>
          {spanish ? content?.UsageTitleSpanish : content?.UsageTitleEnglish}
        </h4>
        {cmsData && (
          <p>{spanish ? cmsData?.UsageSpanish : cmsData?.UsageEnglish}</p>
        )}
      </div>
    )}

    {cmsData?.Ingredients && (
      <div className={styles.block} ref={refToIngredients}>
        <h4>
          {spanish
            ? content?.IngredientsTitleSpanish
            : content?.IngredientsTitleEnglish}
        </h4>
        <div className={styles.images}>
          {cmsData?.imagesIngredients.map((item, key) => (
            <img
              key={key}
              src={Config.cdn.cdn_path + item?.url}
              alt={spanish ? 'ingredientes' : 'ingredients'}
            />
          ))}
        </div>
      </div>
    )}

    {cmsData?.IngredientList && (
      <div className={styles.end}>
        <h5>
          {spanish
            ? content?.IngredientListSpanish
            : content?.IngredientListEnglish}
        </h5>
        <p>
          {spanish
            ? cmsData?.IngredientListSpanish
            : cmsData?.IngredientListEnglish}
        </p>
      </div>
    )}

    <div className={styles.block}>
      <Certificates cmsData={cmsData} content={content} spanish={spanish} />
    </div>
  </div>
);

export default ProductDescription;
